import { toProxiedCdnImageSrc } from './proxiedImageSrc';
import { isStoredMediaUrl } from '../services/mediaService';

/** Instagram CDN URLs are signed per size — never rewrite them. */
export function resolveChefImageUrl(url?: string, _variant: 'thumb' | 'large' = 'large'): string | undefined {
    const trimmed = url?.trim();
    return trimmed || undefined;
}

/** Route images through storage read URL or CDN proxy. */
export function toChefImageSrc(url?: string): string | undefined {
    const trimmed = resolveChefImageUrl(url);
    if (!trimmed) return undefined;
    if (isStoredMediaUrl(trimmed)) return trimmed;
    return toProxiedCdnImageSrc(trimmed);
}
